const initialState = {
  rtl: false,
  token: null,
  role: null,
  language: null,
  refresh: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "ADD_TOKEN":
      return { ...state, token: action.token };
    case "REFRESH":
      return { ...state, refresh: !state.refresh };
    case "CHANGE_LANGUAGE":
      return { ...state, language: action.language };
    case "DELETE_TOKEN":
      return { ...state, token: null };
    case "LOGIN":
      return { ...state, token: action.token, role: action.role };
    case "SET_RTL":
      return { ...state, rtl: action.rtl, language: action.language };
    default:
      return state;
  }
}
